import { Component, computed, inject, input } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";
import { StoreGetDTO } from "src/app/pages/store-management/stores/store";

export type StoreConfigStatusVariant = "success" | "partial" | "incomplete";

@Component({
  selector: "app-dashboard-store-config-status-widget",
  standalone: true,
  imports: [MaterialModule, TranslateModule],
  templateUrl: "./dashboard-store-config-status-widget.component.html",
  styleUrl: "./dashboard-store-config-status-widget.component.scss",
})
export class DashboardStoreConfigStatusWidgetComponent {
  private readonly router = inject(Router);

  readonly stores = input.required<StoreGetDTO[]>();

  readonly totalStores = computed(() => this.stores().length);
  readonly completeCount = computed(
    () =>
      this.stores().filter((store) => store.onboarding?.isComplete === true)
        .length,
  );
  readonly allComplete = computed(
    () =>
      this.totalStores() > 0 &&
      this.completeCount() === this.totalStores(),
  );
  readonly statusVariant = computed<StoreConfigStatusVariant>(() => {
    if (this.allComplete()) {
      return "success";
    }

    if (this.completeCount() > 0) {
      return "partial";
    }

    return "incomplete";
  });

  navigateToStores(): void {
    void this.router.navigate(["/store/stores"]);
  }
}
